import React, { useEffect, useState } from 'react';
import './Header.css';
import logoLight from '../../assets/new_summit_logo/logo-light.png';
import useClickSound from '../../hooks/useClickSound';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const playClickSound = useClickSound();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavLinkClick = (e) => {
    e.preventDefault();
    playClickSound();
    
    // Get the href value and target element
    const targetId = e.target.getAttribute('href').slice(1);
    const targetElement = document.getElementById(targetId);
    
    // Close mobile menu
    setIsMenuOpen(false);
    
    // Scroll to target section
    if (targetElement) {
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  };

  const handleToggleClick = () => {
    playClickSound();
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      <nav className={`navbar navbar-expand-lg navbar-dark fixed-top ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <a className="navbar-brand" href="#home" onClick={handleNavLinkClick}>
            <img src={logoLight} alt="Summit Logo" />
          </a>
          <button 
            className="navbar-toggler" 
            type="button" 
            aria-controls="navbarNav" 
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
            onClick={handleToggleClick}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div 
            className={`navbar-collapse justify-content-center ${isMenuOpen ? 'show' : 'collapse'}`} 
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item"><a onClick={handleNavLinkClick} className="nav-link" href="#home">Home</a></li>
              <li className="nav-item"><a onClick={handleNavLinkClick} className="nav-link" href="#features">Features</a></li>
              <li className="nav-item"><a onClick={handleNavLinkClick} className="nav-link" href="#about">About</a></li>
              <li className="nav-item"><a onClick={handleNavLinkClick} className="nav-link" href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;